const bytesToGigaBytes = (n: number) => n / Math.pow(1024, 3);

export default bytesToGigaBytes;
